/**
 * @generated SignedSource<<5abe95dbcc91870d625ce07288555b74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SourceTagReferenceModal_Query$variables = {
  funnelSlug: string;
};
export type SourceTagReferenceModal_QueryVariables = SourceTagReferenceModal_Query$variables;
export type SourceTagReferenceModal_Query$data = {
  readonly funnel: {
    readonly name: string;
    readonly sourceTags: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly key: string | null;
          readonly value: string | null;
          readonly source: {
            readonly id: string;
            readonly name: string;
          };
          readonly pageUrl: string;
        } | null;
      } | null> | null;
    };
  };
};
export type SourceTagReferenceModal_QueryResponse = SourceTagReferenceModal_Query$data;
export type SourceTagReferenceModal_Query = {
  variables: SourceTagReferenceModal_QueryVariables;
  response: SourceTagReferenceModal_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "funnelSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "funnelSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 500
    }
  ],
  "concreteType": "SourceTagConnection",
  "kind": "LinkedField",
  "name": "sourceTags",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SourceTagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SourceTag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Source",
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sourceTags(first:500)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceTagReferenceModal_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Funnel",
        "kind": "LinkedField",
        "name": "funnel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceTagReferenceModal_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Funnel",
        "kind": "LinkedField",
        "name": "funnel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93a4fe91a7d827a602564459561c2b2e",
    "id": null,
    "metadata": {},
    "name": "SourceTagReferenceModal_Query",
    "operationKind": "query",
    "text": "query SourceTagReferenceModal_Query(\n  $funnelSlug: String!\n) {\n  funnel(slug: $funnelSlug) {\n    name\n    sourceTags(first: 500) {\n      edges {\n        node {\n          id\n          key\n          value\n          source {\n            id\n            name\n          }\n          pageUrl\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c013e4bd77e3d5655427170d0e3623e4";

export default node;
